import React, { useEffect } from "react";
import { scheduleModalCleanup } from "../../../utils/helpers/modalLifecycle";
import "./overlay-loading.css";
import AkasLogo from "../../AkasLogo";

const OverlayLoading = ({
  isShow = false,
  title = "Memuat data",
  message = "Sebentar, kami sedang menyiapkan halaman Anda.",
}) => {
  useEffect(() => {
    if (!isShow) scheduleModalCleanup();

    return () => {
      scheduleModalCleanup();
    };
  }, [isShow]);

  return (
    <div
      className={`akas-loading-overlay ${isShow ? "is-visible" : ""}`}
      id="modal-overlay-loading"
      tabIndex="-1"
      role="status"
      aria-hidden={!isShow}
      aria-busy={isShow}
      aria-live="polite"
      data-app-overlay="loading"
      style={{ display: isShow ? "grid" : "none" }}>
      <div className="akas-loading-decoration decoration-left" aria-hidden="true" />
      <div className="akas-loading-decoration decoration-right" aria-hidden="true" />
      <div className="akas-loading-card">
        <div className="akas-loading-brand" aria-hidden="true">
          <AkasLogo className="akas-loading-mark" decorative />
          <strong>Akas</strong>
        </div>
        <div className="akas-loading-copy">
          <h2>{title}</h2>
          <p>{message}</p>
        </div>
        <div className="akas-loading-progress" aria-hidden="true">
          <span />
          <span />
          <span />
        </div>
        <div className="akas-loading-security">
          <span aria-hidden="true">✓</span>
          <small>Koneksi aman · data usaha tetap terlindungi</small>
        </div>
      </div>
    </div>
  );
};

export default OverlayLoading;
